import * as types from './imprimirSolicitacao.actionTypes';
import * as commonActionType from '@common/store/common/common.actionsType';
import store from '@common/store/store';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  tokenRecaptcha: '',
  tokenRecaptchaModal: '',
  PesquisaProtocoloModalToggle: false,
  GridImprimirSolicitacaoPesquisa: [],
  recaptchaResetRef: undefined,
  recaptchaResetRefModal: undefined,
});

const reduce = (state = initialState, action = {}) => {
  const { payload } = action;
  switch (action.type) {
    case types.SET_TOKEN_RECAPTCHA:
      return state.merge({ tokenRecaptcha: payload });
    case types.SET_TOKEN_RECAPTCHA_MODAL:
      return state.merge({ tokenRecaptchaModal: payload });
    case types.TOGGLE_MODAL_IMPRIMIR_SOLICITACAO:
      return state.merge({ PesquisaProtocoloModalToggle: !state.PesquisaProtocoloModalToggle });
    case types.SET_GRID_PESQUISA_IMPRIMIR_SOLICITACAO:
      return state.merge({ GridImprimirSolicitacaoPesquisa: payload });
    case types.LIMPA_GRIDS_IMPRIMIR_SOLICITACAO:
      return state.merge({ GridImprimirSolicitacaoPesquisa: [] });
    case types.SET_RECAPTCHA_RESET_REF:
      return state.merge({ recaptchaResetRef: payload });
    case types.SET_RECAPTCHA_RESET_REF_MODAL:
      return state.merge({ recaptchaResetRefModal: payload });
    case commonActionType.RESET:
      return initialState;
    default:
      return state;
  }
};

store.registerDynamicModule('redeSIM.imprimirSolicitacao', reduce);
